<span *ngIf="cdoSeverity === 'RED'" class="cdo-red">Red</span>
<span *ngIf="cdoSeverity === 'YELLOW'" class="cdo-yellow">Yellow</span>